import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcCreateFabric = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M10.847 2.357a1.5 1.5 0 0 1 1.114 0l8.282 3.313a.5.5 0 0 1 0 .929l-8.282 3.313a1.5 1.5 0 0 1-1.114 0L2.564 6.599a.5.5 0 0 1 0-.929l8.283-3.313ZM2.564 11.42 5.9 10.086l4.205 1.682a3.5 3.5 0 0 0 2.6 0l4.205-1.682 3.334 1.334a.5.5 0 0 1 0 .929l-8.282 3.313a1.5 1.5 0 0 1-1.114 0l-8.283-3.313a.5.5 0 0 1 0-.929Zm0 5.748L5.9 15.835l4.205 1.681a3.5 3.5 0 0 0 2.6 0l1.32-.528A2.99 2.99 0 0 0 13.25 19c0 .625.191 1.206.519 1.686l-1.808.724a1.5 1.5 0 0 1-1.114 0l-8.283-3.313a.5.5 0 0 1 0-.929Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M19.25 15a1 1 0 0 0-1 1v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2a1 1 0 0 0-1-1Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcCreateFabric");

export { IcCreateFabric };
//# sourceMappingURL=ic-create-fabric.js.map
